<template>
  <div>
    <slot
      :data="data"
      :dataGrouped="dataGrouped"
      :search="search"
      :filter="filter"
      :orderBy="orderBy"
      :orderType="orderType"
      :setSearch="setSearch"
      :setFilter="setFilter"
      :setFilterKey="setFilterKey"
      :clearFilter="clearFilter"
      :getFilterKey="getFilterKey"
      :setOrderBy="setOrderBy"
      :setOrderType="setOrderType"
      :loadGroups="loadGroups"
      :isLoading="isLoading"
      :isFiltered="isFiltered"
    >
    </slot>
  </div>
</template>

<script>
import LoadsData from "../Mixins/LoadsData";

export default {
  mixins: [LoadsData],
};
</script>